/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_uc_data_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manufacturers count 1 TB as 1,000,000,000,000 bytes (decimal), but your operating system's file manager often counts in binary (1 TiB = 1,099,511,627,776 bytes) while still labeling it 'GB' or 'TB.' The drive isn't missing space — 1,000,000,000,000 bytes divided by the binary GB size just displays as about 931 GB.`)
};

const es_uc_data_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Los fabricantes cuentan 1 TB como 1,000,000,000,000 bytes (decimal), pero el administrador de archivos de tu sistema operativo a menudo cuenta en binario (1 TiB = 1,099,511,627,776 bytes) mientras lo etiqueta 'GB' o 'TB.' El disco no está faltando espacio — 1,000,000,000,000 bytes divididos por el tamaño binario de GB solo se visualizan como aproximadamente 931 GB.`)
};

const de_uc_data_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hersteller zählen 1 TB als 1,000,000,000,000 Byte (dezimal), aber der Dateimanager Ihres Betriebssystems zählt oft binär (1 TiB = 1,099,511,627,776 Byte), beschriftet es aber trotzdem mit 'GB' oder 'TB'. Der Festplatte fehlt kein Speicherplatz — 1,000,000,000,000 Byte geteilt durch die binäre GB-Größe wird einfach als etwa 931 GB angezeigt.`)
};

const nl_uc_data_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fabrikanten tellen 1 TB als 1.000.000.000.000 bytes (decimaal), maar uw besturingssysteem bestandsmanager telt vaak binair (1 TiB = 1.099.511.627.776 bytes) terwijl nog steeds 'GB' of 'TB' label. De schijf mist geen ruimte — 1.000.000.000.000 bytes gedeeld door de binaire GB grootte geeft gewoon ongeveer 931 GB.`)
};

const fr_uc_data_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les fabricants comptent 1 TB comme 1 000 000 000 000 octets (décimal), mais le gestionnaire de fichiers de votre système d'exploitation compte souvent en binaire (1 TiB = 1 099 511 627 776 octets) tout en le qualifiant de 'GB' ou 'TB.' Le lecteur n'a pas d'espace manquant — 1 000 000 000 000 octets divisés par la taille binaire du GB s'affiche juste comme environ 931 GB.`)
};

const it_uc_data_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I produttori contano 1 TB come 1.000.000.000.000 byte (decimale), ma il manager di file del tuo sistema operativo spesso conta in binario (1 TiB = 1.099.511.627.776 byte) mentre lo etichetta ancora come 'GB' o 'TB.' L'unità non sta perdendo spazio — 1.000.000.000.000 byte diviso per la dimensione binaria GB semplicemente visualizza come circa 931 GB.`)
};

const pt_br2_uc_data_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fabricantes contam 1 TB como 1.000.000.000.000 bytes (decimal), mas o gerenciador de arquivos do seu sistema operacional frequentemente conta em binário (1 TiB = 1.099.511.627.776 bytes) enquanto ainda o rotula como 'GB' ou 'TB.' O drive não está faltando espaço — 1.000.000.000.000 bytes dividido pelo tamanho binário de GB apenas exibe como cerca de 931 GB.`)
};

const pt_uc_data_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Os fabricantes contam 1 TB como 1000000000000 bytes (decimal), mas o gestor de ficheiros do seu sistema operatiu frequentemente conta em binário (1 TiB = 1099511627776 bytes) enquanto ainda o rotula como 'GB' ou 'TB.' A unidade não está a perder espaço — 1000000000000 bytes dividido pelo tamanho GB binário apenas apresenta como cerca de 931 GB.`)
};

const ja_uc_data_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メーカーは1 TB を1,000,000,000,000バイト(10進)とカウントしますが、オペレーティングシステムのファイルマネージャーはしばしば2進(1 TiB = 1,099,511,627,776バイト)でカウントしながら、それを「GB」または「TB」のままラベルが付けています。ドライブはスペースを欠いていません — 1,000,000,000,000バイトは2進 GB サイズで除算されると、約931 GB のように表示されるだけです。`)
};

const zh_uc_data_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`[pending translation B]`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const uc_data_faq1_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.uc_data_faq1_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("uc_data_faq1_a", locale)
	if (locale === "en") return en_uc_data_faq1_a(inputs)
	if (locale === "es") return es_uc_data_faq1_a(inputs)
	if (locale === "de") return de_uc_data_faq1_a(inputs)
	if (locale === "nl") return nl_uc_data_faq1_a(inputs)
	if (locale === "fr") return fr_uc_data_faq1_a(inputs)
	if (locale === "it") return it_uc_data_faq1_a(inputs)
	if (locale === "pt-BR") return pt_br2_uc_data_faq1_a(inputs)
	if (locale === "pt") return pt_uc_data_faq1_a(inputs)
	if (locale === "ja") return ja_uc_data_faq1_a(inputs)
	return zh_uc_data_faq1_a(inputs)
};